import { render, staticRenderFns } from "./K4List.vue?vue&type=template&id=783ddda0"
import script from "./K4List.vue?vue&type=script&lang=js"
export * from "./K4List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports